import { render, staticRenderFns } from "./CarsBoatsVehiclesFS.vue?vue&type=template&id=56b6d418&scoped=true"
import script from "./CarsBoatsVehiclesFS.vue?vue&type=script&lang=ts"
export * from "./CarsBoatsVehiclesFS.vue?vue&type=script&lang=ts"
import style0 from "./CarsBoatsVehiclesFS.vue?vue&type=style&index=0&id=56b6d418&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b6d418",
  null
  
)

export default component.exports